import {
  CONVERSATION_ACTION_TYPES,
  OPPORTUNITY_ACTION_TYPES,
} from './actionTypes';

const conversationActionsExcept = excludedKeys =>
  CONVERSATION_ACTION_TYPES.filter(({ key }) => !excludedKeys.includes(key));

export const standardActions = conversationActionsExcept([]);

export const conversationOpenedActions = conversationActionsExcept([
  'resolve_conversation',
  'conversation_opened',
]);

export const opportunityActions = [...OPPORTUNITY_ACTION_TYPES];
